<script lang="ts" setup>
import TextButton from '@/components/input/Btn/TextButton.vue';
import { i18n } from '@/i18n';
import NumberInput from '@/orderCalendarModule/components/NumberInput.vue';

const t = i18n.t;
const props = withDefaults(
  defineProps<{
    popUpState: boolean;
    modelValue: number;
  }>(),
  {}
);

const emits = defineEmits<{
  (e: 'update:modelValue', changedValue: number): void;
  (e: 'close'): void;
  (e: 'confirm'): void;
}>();
</script>
<template>
  <div class="order-package-input">
    <div v-show="popUpState" class="order-package-input__outside" @click="emits('close')" />
    <div v-if="popUpState" class="order-package-input__container">
      <NumberInput
        :model-value="modelValue"
        :label="t('発注単位(詳細ページ)')"
        :placeholder="t('発注単位')"
        :has-border="true"
        @update:model-value="(e) => emits('update:modelValue', e)"
      />
      <div class="order-package-input__button__container">
        <TextButton :button-style="'btn-secondary'" :size="'btn-ss'" @click="emits('close')">
          {{ t('キャンセル') }}
        </TextButton>
        <TextButton :button-style="'btn-primary'" :size="'btn-ss'" @click="emits('confirm')">
          {{ t('変更') }}
        </TextButton>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.order-package-input {
  &__outside {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: $transparency0;
  }

  &__container {
    position: relative;
    z-index: 1;

    padding: 8px 8px 16px 8px;
    gap: 6px;

    display: grid;
    grid-template-rows: auto auto;

    border-radius: 8px;
    border-width: 1px;
    border-color: $borderDefault;
    background-color: $semanticWhite;
    box-shadow: $boxShadowM;
  }

  &__input {
    border: 1px solid $borderDefault;
  }

  &__button__container {
    display: grid;
    grid-template-columns: auto auto;
    gap: 4px;
  }
}
</style>
